import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';

import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsUUID } from 'class-validator';
import { JobDto } from '../../job/dto/job.dto';
import { JobOptionInterface } from '../interfaces/job-option.interface';
import { OptionDto } from '../../option/dto/option.dto';

@Exclude()
export class JobOptionDto
  extends CommonEntityDto
  implements JobOptionInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Job Option ID',
  })
  @IsUUID()
  @Expose()
  jobOptionId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job ID',
  })
  @IsUUID()
  @Expose()
  jobId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Option ID',
  })
  @IsUUID()
  @Expose()
  optionId!: string;

  @ApiPropertyOptional({
    type: () => JobDto,
    title: 'Associated Job',
    description: 'The job associated with this job option',
  })
  @Expose()
  job?: JobDto;

  @ApiPropertyOptional({
    type: () => OptionDto,
    title: 'Associated Option',
    description: 'The Option associated with this job option',
  })
  @Expose()
  option?: OptionDto;
}
